import { required, TextInput } from "react-admin";
import { Grid, Typography, useMediaQuery } from "@mui/material";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { settings } from "app";
import ImagePreview from "./ImagePreview";
import { RichTextInput } from "ra-input-rich-text";
import PublicCustomImageInput from "components/EnrollingStudents/Partials/PublicCustomImageInput";

const BaseForm = ({ setEventLogoImageId, isDisableEventUpload, setIsDisableEventUpload, record = null }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <Grid
      container
      spacing={2}
      sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
    >
      <Grid
        item
        xs={12}
      >
        <Typography color="primary">Данни за събитиетото</Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="title"
          label="Заглавие"
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="subtitle"
          label="Подзаглавие"
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={10}
      >
        <RichTextInput
          source="content"
          label="Съдържание"
          variant="outlined"
          fullWidth
          sx={settings.style.richTextInput}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="location"
          label="Локация"
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <CustomDateInput
          source="startsAt"
          label="Стартова дата"
          required={true}
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
      >
        <Typography
          color="primary"
          sx={{ fontSize: "12px" }}
          fontWeight={"bold"}
          mb={2}
        >
          Водеща снимка
        </Typography>
        {record?.imageId && <ImagePreview id={record?.imageId} />}
        <PublicCustomImageInput
          source="imageId"
          name="imageId"
          helperText={".jpeg, .jpg, .png"}
          isDisable={isDisableEventUpload}
          setIsDisable={setIsDisableEventUpload}
          label={` `}
          SubCategoryId={13}
          setDataId={setEventLogoImageId}
        />
      </Grid>
    </Grid>
  );
};
export default BaseForm;
